export default __webpack_public_path__ + "static/media/pope_worldwide_de.366da7db.svg";